export {
  mapDtoToTickets,
  mapDtoToTicketsPage,
  mapDtoToTicketTypes,
} from "./mappers";
export type { TicketsPageType, TicketsType, TicketTypesType } from "./types";
